import React from "react";

const TableWrapper = ({ children }) => {
  return <table className="w-full">{children}</table>;
};

export default TableWrapper;
